export async function turboDownloadAttachment(event) {
  const response =
    event.detail?.formSubmission?.result?.fetchResponse?.response;

  if (
    response &&
    response.headers.get("content-disposition")?.includes("attachment")
  ) {
    const url = URL.createObjectURL(await response.blob());
    const link = document.createElement("a");

    link.href = url;
    link.setAttribute(
      "download",
      decodeURIComponent(
        response.headers.get("content-disposition").split('"')[1],
      ),
    );

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

    URL.revokeObjectURL(url);
  }
}
